import { put } from "redux-saga/effects";

import { readFromLocalStorage } from "common/utilities/localStorage";
import { logger } from "common/utilities/logger";
import { fetchCoachmarksVisibilityStatusSuccess } from "domains/coachmarks/actions";

export function* fetchCoachmarksVisibilityStatusSaga() {
  let coachmarksVisibilityStatus = true;
  try {
    const value = readFromLocalStorage("COACHMARKS_VISIBILITY_STATUS");
    if (typeof value === "boolean") coachmarksVisibilityStatus = value;
  } catch (error) {
    logger.error(
      "[fetchCoachmarksVisibilityStatusSaga] Error occurred while fetching coachmarks visibility status",
      error,
    );
  }

  yield put(fetchCoachmarksVisibilityStatusSuccess(coachmarksVisibilityStatus));
}
